export const formActionParametersData = (paramsNames: string[]) => {
    let result = {}
    paramsNames.map((el: any) => (result = { ...result, [el]: null }))

    return result
}
